module.exports = __webpack_public_path__ + "static/media/trainingProgressTile.af6bea18.jpg";